module.exports = __webpack_public_path__ + "static/events-white-light-81f98653fa9545ec8494725640cf0c15.jpg";